var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.06 0.06)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.8 181.136c-10.24 0-20.48 0-30.72 5.12l430.080 404.48c20.48 20.48 51.2 20.48 71.68 0l435.2-404.48c-10.24-5.12-20.48-5.12-30.72-5.12-5.12 0-875.52 0-875.52 0zM5.12 216.976c0 10.24-5.12 20.48-5.12 35.84v522.24c0 10.24 5.12 20.48 10.24 30.72l322.56-281.6-327.68-307.2zM1018.88 216.976l-327.68 307.2 322.56 281.6c5.12-10.24 10.24-20.48 10.24-30.72v-522.24c0-15.36-5.12-25.6-5.12-35.84zM655.36 560.016l-71.68 66.56c-40.96 35.84-102.4 35.84-143.36 0l-71.68-66.56-322.56 281.6c10.24 5.12 20.48 5.12 30.72 5.12h875.52c10.24 0 20.48 0 30.72-5.12l-327.68-281.6z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.4eb79383279405aa816209138b32797d.svg";
export { ForwardRef as ReactComponent };